import moment from 'moment/moment'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ENV } from '../../ENV'
import logo from '../Header/logo_mmr_bile_rgb.svg'

const MaintenanceMode = ({ children }: { children: React.ReactNode }) => {
  if (!ENV.MAINTENANCE_MODE) {
    return <>{children}</>
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexFlow: 'column' }}>
      <HeaderSimple />
      <main role='main' id='content' style={{ flexGrow: 1 }}>
        <div style={{ maxWidth: 850, margin: '0px auto', padding: '80px 15px' }}>
          <h5 style={{ fontSize: 22 }}>Odstávka VVZ</h5>
          <br />
          Vážení zadavatelé,
          <br />
          <br />
          vzhledem k povinnému přechodu Věstníku veřejných zakázek na novou verzi SDK 1.13 evropských eForms, která
          reflektuje poslední změnové nařízení Komise (EU) 2023/2884, <strong>právě probíhá plánovaná odstávka</strong>.
          <br />
          Níže uvádíme podrobnější informace:
          <br />
          <br />
          <strong>Od úterý 22. dubna 2025 od 8:00</strong> je Věstník kompletně nedostupný, a proto je zobrazena pouze
          informace o probíhající plánované odstávce.
          <br />
          <br />
          <strong>Od čtvrtka 24. dubna 2025 od 8:00</strong> bude opět obnoven plný provoz Věstníku včetně možnosti
          podávat a uveřejňovat formuláře již v nové podobě eForms ve verzi SDK 1.13.
        </div>
      </main>
      <FooterSimple />
    </div>
  )
}

const HeaderSimple = () => (
  <header
    className={
      'gov-container gov-container--wide gov-container--no-y-offset gov-header ' + (ENV.REF_ENV ? ' ref-header ' : '')
    }
  >
    <div className='gov-container__content'>
      <div className='gov-header__holder'>
        <div className='gov-header__left' style={{ display: 'flex' }}>
          <a href='https://mmr.cz/cs/uvod' target='_blank' rel='noreferrer noopener' className='gov-footer__image-link'>
            <img alt='MMR logo' src={logo} className='mmr-logo' />
          </a>

          {ENV.REF_ENV ? (
            <a className='gov-logo gov-logo--inversed ref-header-logo' href='/'>
              VĚSTNÍK VEŘEJNÝCH ZAKÁZEK
              <small>TESTOVACÍ PROSTŘEDÍ</small>
            </a>
          ) : (
            <a className='gov-logo gov-logo--inversed' href='/'>
              VĚSTNÍK VEŘEJNÝCH ZAKÁZEK
            </a>
          )}
        </div>
      </div>
    </div>
  </header>
)

const FooterSimple = () => {
  const { t } = useTranslation()

  return (
    <footer className='gov-container gov-container--wide gov-footer u-bg-color--grey-dark'>
      <div className='gov-container__content'>
        <section className='gov-footer__lower'>
          <p className='gov-footnote'>
            {moment().year()} &copy; {t('footer.copy')}
          </p>
          <p className='gov-footnote'>
            {t('footer.verze', 'Verze')} {ENV.VERSION}
          </p>
        </section>
      </div>
    </footer>
  )
}

export default MaintenanceMode
